import React from 'react'
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import track from './images/track.jpg'

const Trans = () => {
    return (
        <>
            <div className="">
                <div className="py-6 ">
                    <div className="relative md:px-10 after:w-[100%] md:after:w-[94%]  baner">
                        <img src={track} alt="value" className='md:h-[70vh] h-[45vh]' />
                        <div className=" absolute top-0 bottom-0 z-10 w-full md:w-[60%] md:left-[21%]  ">
                            <div className="md:mx-16 mx-5 md:pt-14 ">
                                <div className="my-10"><h1 className='font-black text-[2.5rem]  tracking-wider text-white'>Transaction</h1>
                                    <h1 className='border-b-8 border-b-[#B5D1B3] w-[4rem]'></h1>
                                </div>
                                <div className="">
                                    <p className='tracking-wider leading-8 text-white text-[1rem] md:text-[1.5rem] font-bold'>Our experienced Transactions team specialises in the land development and agribusiness sectors stewarding the sale of some of Australia’s most significant real estate assets.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text">
                    <div className="md:w-[57%] w-full  md:mx-[21rem] py-12">
                        <p className=' mx-4 md:mx-0 leading-7 tracking-wide'>LAWD’s professionals have worked across agricultural sectors through many market cycles and conditions to develop an unparalleled depth of knowledge. This is complemented by a commitment to being adaptive and innovative in their selling techniques.</p>
                        <p className='leading-7 md:mx-0 mx-4  py-6 tracking-wide'>Our land development specialists have a proven sales record in large englobo sites, master-planned communities, and super lots within master-planned communities in all greenfield growth corridors.</p>
                        <p className='leading-7 md:mx-0 mx-4 py-6 tracking-wide'>We pride ourselves on building connections and partnerships that go beyond the financial transaction. To do this, we cultivate domestic and international networks of valued relationships, from private landowners to corporate businesses and publicly listed organisations, to efficiently match buyers with sellers.</p>

                        <button className='border tracking-wider md:mx-0 mx-4 border-[#004a8b] text-[#004a8b] px-5 py-3 text-[13px] hover:border-[#B5D1B3] hover:bg-[#B5D1B3] hover:text-[black]'>CONTACT OUR TEAMS</button>
                    </div>

                    <div className="">
                        <div className="flex md:mx-[17rem]  pb-10 pt-[4rem]">
                            <button className='md:px-0 px-5'>
                                <Link to='/OurServices' className='text-[#004a8b] flex'>
                                    <FaArrowLeft className='text-[#B5D1B3] font-black text-[1.6rem] w-[100%] mx-5' /><h1 className='my-1 md:mx-0 mx-3 text-[12px] font-black tracking-widest'>Valuation</h1></Link>
                            </button>
                            <h1 className='text-[10px]font-bold md:block hidden md:mx-[13rem] w-[12%] text-center justify-center border-b-2 border-[#004a8b] tracking-wider text-[#004a8b] '>
                                <span className='text-[12px] font-black'>TRANSACTION</span>
                            </h1>
                            <button>
                                <Link to='/AdServices' className='text-[#004a8b] flex'><h1 className='my-1 md:mx-0 mx-3 text-[12px] font-black tracking-widest'>Advisory</h1><FaArrowRight className='text-[#B5D1B3] font-black text-[1.6rem] w-[100%] mx-5' /></Link>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Trans